import { BinaryCreateCmd, BinaryEntity } from '@edgvr-front/binaries/domain';
import { createAction, props } from '@ngrx/store';

export const binaryBatchCreate = createAction(
  '[Binaries/API] Binary Batch Create',
  props<{ batch: BinaryCreateCmd[] }>()
);
export const binaryBatchItemCreateSuccess = createAction(
  '[Binaries/API] Binary Batch Item Create Success',
  props<{ binary: BinaryEntity }>()
);
export const binaryBatchCreateSuccess = createAction(
  '[Binaries/API] Binary Batch Create Success'
);
export const binaryBatchCreateFailure = createAction(
  '[Binaries/API] Binary Batch Create Failure'
);

export const listLatest = createAction('[Binaries/API] List Latest');
export const listLatestSuccess = createAction(
  '[Binaries/API] List Latest Success',
  props<{ binaries: BinaryEntity[] }>()
);
export const listLatestFailure = createAction(
  '[Binaries/API] List Latest Failure'
);
